<span [innerHTML]="value?value:'&nbsp;'" [style.height.px]="rows*25" *ngIf="visible" [style.textAlign]="textAlign" 
style="display: table;margin: 5px; width: 100%;white-space: pre-line;"></span> 